import { StreamChat } from 'stream-chat';

import { UserData, client, getIsOrganizerToken } from '@bizzabo/entities';
import { instanaReportError } from '@bizzabo/instana-api';

const GetStreamUserTokenKey = 'GetStreamUserToken';

type ProviderUser = {
    providerUserId: string;
    provider: string;
    token: string;
};

const fetchToken = async (eventId: number, accountId: number, isJoinChannelAsync = false) => {
    if (getIsOrganizerToken()) {
        const body = {
            provider: 'GET_STREAM',
        };
        return (
            await client().post(`/api/v2/chat/accounts/${accountId}/portals/${eventId}/users`, body)
        ).data as ProviderUser;
    }

    if (isJoinChannelAsync) {
        const body = {
            provider: 'GET_STREAM',
        };
        return (await client().post(`/api/v2/chat/events/${eventId}/chat/users`, body))
            .data as ProviderUser;
    }

    return (await client().post(`/api/v2/chat/events/${eventId}/chat/users/GET_STREAM/`))
        .data as ProviderUser;
};

const localUser = {
    get(key: string) {
        let result: ProviderUser;
        try {
            result = JSON.parse(localStorage.getItem(key));
        } catch (error) {
            instanaReportError({ error });
        }
        return result;
    },
    set(key: string, user: ProviderUser) {
        localStorage.setItem(key, JSON.stringify(user));
    },
};

const connectUser = async (
    client: StreamChat,
    eventId: number,
    user: UserData,
    accountId: number,
    isJoinChannelAsync = false
) => {
    const tokenKey = GetStreamUserTokenKey + '-' + user.id + '-' + eventId;
    let chatUser = localUser.get(tokenKey);

    if (!chatUser) {
        chatUser = await fetchToken(eventId, accountId, isJoinChannelAsync);
        localUser.set(tokenKey, chatUser);
    }

    // only send to GetStream this values
    const userToSend = {
        name: `${user.firstName} ${user.lastName}`,
        firstName: user.firstName,
        lastName: user.lastName,
        company: user.company,
        country: user.country,
        industry: user.industry,
        photoUrl: user.photoUrl,
        title: user.title,
        isHidden: user.isHidden,
        id: chatUser.providerUserId,
    };

    return client.connectUser(userToSend, chatUser.token);
};

export default connectUser;
